import React, { useEffect, useState } from 'react';

export default function CheckoutSuccess() {
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const checkoutId = urlParams.get('checkout_id');
    setTimeout(() => setStatus('success'), 2000);
  }, []);

  const handleGoToApp = () => {
    window.location.href = '/';
  };

  if (status === 'loading') {
    return (
      <div style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        background: '#0a0a0a',
        color: '#fff',
        fontFamily: 'system-ui, sans-serif'
      }}>
        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
        <h2>Processing your payment...</h2>
      </div>
    );
  }

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center',
      background: '#0a0a0a',
      color: '#fff',
      fontFamily: 'system-ui, sans-serif',
      textAlign: 'center'
    }}>
      <div style={{ 
        width: '80px', 
        height: '80px', 
        borderRadius: '50%', 
        background: 'linear-gradient(135deg, #008081, #4B2C5E)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '2.5rem',
        marginBottom: '1.5rem'
      }}>✓</div>
      
      <h1>Welcome to Premium!</h1>
      <p style={{ color: 'rgba(255,255,255,0.6)', maxWidth: '400px' }}>
        Your payment was successful. Premium features are now active.
      </p>

      <button 
        onClick={handleGoToApp}
        style={{
          padding: '1rem 2rem',
          background: 'linear-gradient(135deg, #008081, #005f5f)',
          color: '#fff',
          border: 'none',
          borderRadius: '0.75rem',
          fontWeight: '700',
          cursor: 'pointer',
          marginTop: '2rem'
        }}
      >
        Start Using Premium
      </button>
    </div>
  );
}